import { render } from "./LogoPanel.vue?vue&type=template&id=02954e5e&scoped=true"
import script from "./LogoPanel.vue?vue&type=script&lang=js"
export * from "./LogoPanel.vue?vue&type=script&lang=js"

import "./LogoPanel.vue?vue&type=style&index=0&id=02954e5e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02954e5e"]])

export default __exports__